/**
 * Features - Classic layout features section
 *
 * Renders Schema, Queue-It, and other feature integrations.
 * Shared between ClassicLayout and AttractionLayout.
 */
import { EventQueueIt } from "../../../components/events/EventQueueIt.web";
import { EventSchema } from "../../../components/events/EventSchema.web";
import type { PageData } from "../../../adapters/types";

interface FeaturesProps {
  data: PageData;
}

export function Features({ data }: FeaturesProps): JSX.Element | null {
  const { features, pageType } = data;

  // Only render for events
  if (pageType !== "event" || !features.eventData) return null;

  return (
    <>
      <EventSchema event={features.eventData} />
      <EventQueueIt event={features.eventData} />
    </>
  );
}
